import jwtDecode from "jwt-decode";

export default class UserSession {

    constructor(storage) {
        this.storage = storage;
    }

    get accessTokenIsMissing() {
        return !this.accessToken;
    }

    get accessToken() {
        return this.storage.getItem('access_token');
    }

    set accessToken(value) {
        this.storage.setItem('access_token', value);
    }

    get accessTokenDecoded() {
        return jwtDecode(this.accessToken);
    }

    get refreshToken() {
        return this.storage.getItem('refresh_token');
    }

    set refreshToken(value) {
        this.storage.setItem('refresh_token', value);
    }

    get accessTokenHasExpired() {
        return this.tokenHasExpired(this.accessToken);
    }

    get refreshTokenIsMissing() {
        return !this.refreshToken;
    }

    get refreshTokenHasExpired() {
        return this.tokenHasExpired(this.refreshToken);
    }

    get refreshTokenIsValid() {
        return this.refreshToken && !this.refreshTokenHasExpired;
    }

    get shouldRemember() {
        return this.storage.getItem('remembered') === 'true';
    }

    set shouldRemember(value) {
        if (value) {
            this.storage.setItem('remembered', 'true');
        } else {
            this.storage.removeItem('remembered');
        }
    }

    get userId() {
        return this.accessTokenDecoded['user_id'];
    }

    get name() {
        return this.accessTokenDecoded['name'];
    }

    get username() {
        return this.accessTokenDecoded['username'];
    }

    get homeUrl() {
        return this.accessTokenDecoded['home_url'];
    }

    get isSystemAdmin() {
        return this.accessTokenDecoded['system_admin'];
    }

    get organizationId() {
        return Number(this.accessTokenDecoded.orgid)
    }

    get isOrganizationAdmin() {
        const accessTokenDecoded = this.accessTokenDecoded;
        const roles = JSON.parse(accessTokenDecoded.roles);
        const organizationId = this.organizationId;

        return roles.some(role => role.orgid === organizationId && role.role === 'Admin');
    }

    tokenHasExpired(jwtString) {
        const decoded = jwtDecode(jwtString);

        const now = new Date().getTime() / 1000;
        return now > decoded["exp"];
    }
}